import { RecursosHumanosState } from './recursos-humanos.reducers';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const recursosHumanosState = createFeatureSelector<RecursosHumanosState>("recursos-humanos");

export const ultimaFichada = createSelector(
	recursosHumanosState,
	state => state.ultimaFichada
);

export const ticketsPendientes = createSelector(
	recursosHumanosState,
	state => state.ticketsPendientes
);

export const recursosHumanosReady = createSelector(
	recursosHumanosState,
	state => state.ready
);